import ApiClient from '@afosto/api/ApiClient';

class Vat {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Upsert vat rates for skus
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Create or update the vat group per country for given skus
   * @returns {Promise}
   */
  attachVatRate(body, options = {}) {
    return this.apiClient.request({
      url: `/cat/vat/products`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Get a list of vat rates
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.administrativeArea] - Florida
   * @param {string} [query.country] - US
   * @param {Object} options - The additional request options
   * @description Get a listing of vat rates per country
   * @returns {Promise}
   */
  getVatList(query = {}, options = {}) {
    const params = {
      administrative_area: query.administrativeArea,
      country: query.country,
    };

    return this.apiClient.request({
      url: `/cat/vat`,
      method: 'get',
      params,
      ...options,
    });
  }
}

export const vat = new Vat();

export default Vat;
